<template>
  <v-app class="layout">
    <v-app-bar
      color="white"
      light
      app
    >
      <v-app-bar-nav-icon
        class="mt-5"
        @click="sidebar = !sidebar"
      />
      <img
        :alt="$t('common.diligence_cloud')"
        src="/storage/diligence-logo.svg"
        id="appbar-logo"
        width="280"
        height="60"
        crossorigin="anonymous"
      >
      <v-spacer />
      <v-chip
        v-if="false"
        title
        color="primary lighten-1"
        label
        pill
        elevation="2"
        class="mr-2 pa-3"
        dark
      >
        <v-avatar>
          <span
            class="white--text text-h6"
          >
            {{ userInitials() }}
          </span>
        </v-avatar>
        {{ `${!administrator ? 'Standard User' : 'Administrator'}` }}
      </v-chip>
      <v-chip
        v-if="account.expiry_policy !== 0 && license.level === 'premium'"
        label
        small
        dark
        class="mr-2"
        color="blue"
      >
        <v-icon
          left
          small
          dark
        >
          mdi-information-variant-circle
        </v-icon>
        {{ !passwordHasExpired ? $t('auth.password_expires_in', { days: expiresAt }) : $t('auth.password_expired') }}
      </v-chip>
      <v-menu
        v-model="licenceMenu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template #activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            left
          >
            mdi-certificate
          </v-icon>
        </template>
        <license-overview
          :modal="true"
          @closeDialog="this.closeLicenceMenu"
        />
      </v-menu>
      <v-tooltip
        bottom
      >
        <template
          #activator="{ on, attrs }"
        >
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="help = true"
          >
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>
          {{ $t('common.help') }}
        </span>
      </v-tooltip>
      <v-tooltip
        bottom
      >
        <template
          #activator="{ on, attrs }"
        >
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            href="/user-logged-out"
          >
            <v-icon>mdi-logout-variant</v-icon>
          </v-btn>
        </template>
        <span>Logout</span>
      </v-tooltip>
      <v-tabs
        align-with-title
        show-arrows
        centered
        slot="extension"
      >
        <v-tab
          v-for="{ label, route, disabled = false, exact = true } in tabs"
          :key="label"
          :to="route"
          :exact="exact"
          :disabled="disabled"
          exact-active-class="comark-active-tab"
        >
          {{ $t(label) }}
        </v-tab>
      </v-tabs>
    </v-app-bar>
    <v-navigation-drawer
      app
      temporary
      v-model="sidebar"
    >
      <v-list>
        <v-list-item
          class="px-2"
        >
          <v-list-item-avatar>
            <v-img
              :src="user.gravatar"
            />
          </v-list-item-avatar>
        </v-list-item>
        <v-list-item
          link
        >
          <v-list-item-content>
            <v-list-item-title
              class="title"
            >
              {{ user.full_name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ user.email }}
            </v-list-item-subtitle>
            <v-list-item-title class="mt-2 caption text-uppercase">
              <span class="font-weight-bold">{{ user.account.account_name }}</span><br>
              {{ account.name }} <account-copy />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list
        nav
        dense
      >
        <v-list-item
          v-for="{ label, icon, route } in userMenu"
          :key="label"
          link
          :to="route"
          exact
          exact-path
        >
          <v-list-item-icon>
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t(label) }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          href="/user-logged-out"
        >
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('common.logout') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container
        fluid
        class="main-container"
      >
        <router-view />
        <v-snackbar
          v-model="snackbar.active"
          :color="snackbar.color"
          multi-line
          class="mb-12"
        >
          <v-icon
            v-if="snackbar.color === 'error'"
            dark
            class="mr-2"
          >
            mdi-alert-outline
          </v-icon>
          <v-icon
            v-if="snackbar.color === 'success'"
            dark
            class="mr-2"
          >
            mdi-check-circle-outline
          </v-icon>
          <span class="subtitle-1">{{ snackbar.text }}</span>
          <template #action="{ attrs }">
            <v-btn
              text
              v-bind="attrs"
              @click="snackbar.active = false"
            >
              {{ snackbar.btn.text }}
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
    <v-footer
      color="grey lighten-2"
      app
    >
      <small>
        {{ app.name }} {{ $t('common.version', {version}) }} {{ licenseTitle }} © {{ new Date().getFullYear() }}
      </small>
      <v-spacer />
      <small>
        <external-links class="comark-footer-links" />
      </small>
      <v-spacer />
      <v-toolbar-title
        class="text-subtitle-2 align-items-center mb-1 primary--text"
        id="appbar-title-company__name"
      >
        <template v-if="account">
          {{ account.company_name }} - <small>{{ account.name }}</small> <account-copy class="mr-2" />
        </template>
      </v-toolbar-title>
    </v-footer>
    <v-speed-dial
      v-if="originalUser"
      bottom
      right
      direction="top"
      open-on-hover
      transition="slide-y-reverse-transition"
      style="position: fixed;bottom: 20px;right: 20px;z-index: 1001;"
    >
      <template #activator>
        <v-tooltip
          left
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="error"
              dark
              fab
            >
              <v-icon>
                mdi-account-convert
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('auth.switched') }}</span>
        </v-tooltip>
      </template>
      <v-btn
        fab
        dark
        small
        color="primary"
        :href="`${app.url}/switch`"
      >
        <v-icon>mdi-account-arrow-left</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-navigation-drawer
      v-model="help"
      app
      right
      temporary
      :width="800"
    >
      <v-list>
        <v-list-item
          class="px-2"
        >
          <v-tooltip
            bottom
          >
            <template
              #activator="{ on, attrs }"
            >
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="help = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('common.close') }}
            </span>
          </v-tooltip>
          <v-list-item-title
            class="ml-2"
          >
            {{ $t('common.help') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider />
      <help-content :open="help" />
    </v-navigation-drawer>
    <dash-settings />
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import HelpContent from './components/help.vue';
import AccountCopy from '../elements/accounts/account-copy.vue';
import DashSettings from '../elements/dashboard/dash-settings.vue';
import LicenseOverview from '../elements/licenses/license-overview.vue';
import ExternalLinks from '../elements/external-links.vue';

export default {
  name: 'MainLayout',
  components: {
    ExternalLinks,
    LicenseOverview,
    DashSettings,
    AccountCopy,
    HelpContent,
  },
  data() {
    return {
      sidebar: false,
      help: false,
      licenceMenu: false,
      notificationsMenu: false,
    };
  },
  computed: {
    ...mapState(['snackbar', 'originalUser']),
    ...mapGetters([
      'app',
      'user',
      'account',
      'license',
      'licenseLevel',
      'isComarkAdmin',
      'can',
      'administrator',
      'version',
      'formatDate',
    ]),
    passwordHasExpired() {
      return new Date() > this.expiresAt;
    },
    tabs() {
      if (this.$route.name.startsWith('admin')) {
        return [
          { label: 'menu.administration', route: { name: 'admin' }, exact: true },
          { label: 'menu.firmware', route: { name: 'admin.firmware' }, exact: true },
        ];
      } if (this.$route.name === 'account.users' || this.$route.name === 'account.user' || this.$route.name === 'account.locations' || this.$route.name === 'account.groups' || this.$route.name === 'account') {
        return [
          ...(this.account ? [{
            label: 'menu.home',
            icon: 'mdi-home',
            route: { name: 'account.dashboard', params: { accountName: this.account.name } },
            exact: false,
          }] : []),
          ...(this.administrator ? [{
            label: 'menu.users',
            icon: 'mdi-account-group',
            route: {
              name: 'account.users',
              params: { accountName: this.$route.params.accountName ?? this.account.name },
            },
            exact: false,
          }] : []),
          {
            label: 'menu.locations',
            icon: 'mdi-map-marker-multiple',
            route: { name: 'account.locations', params: { accountName: this.$route.params.accountName ?? this.account.name } },
            exact: false,
          },
          {
            label: 'menu.groups',
            icon: 'mdi-alarm-multiple',
            route: { name: 'account.groups', params: { accountName: this.$route.params.accountName ?? this.account.name } },
            exact: false,
          },
          {
            label: 'menu.account',
            icon: 'mdi-domain',
            route: { name: 'account', params: { accountName: this.$route.params.accountName ?? this.account.name } },
            exact: true,
          },
        ];
      } if (this.$route.name.startsWith('account')) {
        if (this.$route.name === 'account.license') {
          return [
            ...(this.account ? [{
              label: 'menu.home',
              icon: 'mdi-home',
              route: { name: 'account.dashboard', params: { accountName: this.account.name } },
              exact: false,
            }] : []),
            { label: 'menu.license', route: { name: 'account.license', params: { accountName: this.$route.params.accountName } }, exact: false },
          ];
        }
        if (this.$route.name === 'account.users.create') {
          return [
            ...(this.account ? [{
              label: 'menu.home',
              icon: 'mdi-home',
              route: { name: 'account.dashboard', params: { accountName: this.account.name } },
              exact: false,
            }] : []),
            ...(this.account ? [{
              label: 'menu.users',
              icon: 'mdi-home',
              route: { name: 'account.users', params: { accountName: this.account.name } },
              exact: false,
            }] : []),
            { label: 'menu.create_user', route: { name: 'account.users.create', params: { accountName: this.$route.params.accountName } }, exact: false },
          ];
        }
        return [
          { label: 'menu.dashboard', route: { name: 'account.dashboard', params: { accountName: this.$route.params.accountName } }, exact: false },
          { label: 'menu.rag_view', route: { name: 'account.rag', params: { accountName: this.$route.params.accountName } }, exact: false },
          { label: 'menu.list_view', route: { name: 'account.list', params: { accountName: this.$route.params.accountName } }, exact: false },
          { label: 'menu.detail_view', route: { name: 'account.detail', params: { accountName: this.$route.params.accountName } }, exact: false },
          { label: 'menu.alarm_view', route: { name: 'account.alarm', params: { accountName: this.$route.params.accountName } }, exact: false },
          { label: 'menu.audit_trail', route: { name: 'account.audit', params: { accountName: this.$route.params.accountName } }, exact: false },
          { label: 'menu.transmitter_management', route: { name: 'account.devices', params: { accountName: this.$route.params.accountName } }, exact: false },
        ];
      } if (this.$route.name.startsWith('profile')) {
        return [
          ...(this.account ? [{
            label: 'menu.home',
            icon: 'mdi-home',
            route: { name: 'account.dashboard', params: { accountName: this.account.name } },
            exact: false,
          }] : []),
          { label: 'common.user_details', route: { name: 'profile' }, exact: true },
          { label: 'auth.change_email', route: { name: 'profile.email' }, exact: true },
          { label: 'auth.change_password', route: { name: 'profile.password' }, exact: true },
          { label: 'menu.my_audit_trail', route: { name: 'profile.activity' }, exact: false },
        ];
      }
      return [];
    },
    userMenu() {
      return [
        // @TODO: menu.home here should use the route configured in the user's preferences (dashboard, rag, detail, etc.)
        ...(this.account ? [{
          label: 'menu.home',
          icon: 'mdi-home',
          route: { name: 'account.dashboard', params: { accountName: this.account.name } },
        }] : []),
        {
          label: 'menu.my_profile',
          icon: 'mdi-account',
          route: { name: 'profile' },
        },
        ...(this.administrator ? [{
          label: 'menu.users',
          icon: 'mdi-account-group',
          route: {
            name: 'account.users',
            params: { accountName: this.$route.params.accountName ?? this.account.name },
          },
        }] : []),
        {
          label: 'menu.locations',
          icon: 'mdi-map-marker-multiple',
          route: { name: 'account.locations', params: { accountName: this.$route.params.accountName ?? this.account.name } },
          exact: true,
        },
        {
          label: 'menu.groups',
          icon: 'mdi-alarm-multiple',
          route: { name: 'account.groups', params: { accountName: this.$route.params.accountName ?? this.account.name } },
          exact: true,
        },
        {
          label: 'menu.account',
          icon: 'mdi-domain',
          route: { name: 'account', params: { accountName: this.$route.params.accountName ?? this.account.name } },
          exact: true,
        },
        ...(this.isComarkAdmin ? [{
          label: 'menu.administration',
          icon: 'mdi-cog',
          route: { name: 'admin' },
        }] : []),
      ];
    },
    licenseTitle() {
      return this.licenseLevel ? `${this.licenseLevel[0].toUpperCase()}${this.licenseLevel.slice(1)}` : this.account.license.license;
    },
    expiresAt() {
      const expiryDate = new Date(this.user.password_changed_at);
      expiryDate.setDate(expiryDate.getDate() + this.account.expiry_policy);
      return this.formatDate(expiryDate);
    },
  },
  created() {
    if (this.$route.query.verified) {
      const state = this.$route.query.verified;
      if (state === 'true') {
        this.success({
          text: this.$t('auth.verify_success'),
          timeout: 5000,
        });
      } else {
        this.error({
          text: this.$t(state === 'expired' ? 'auth.verify_expired' : 'auth.verify_failed'),
          timeout: 5000,
        });
      }
    }
  },
  methods: {
    ...mapActions(['success', 'error']),
    closeLicenceMenu() {
      if (this.licenceMenu) this.licenceMenu = false;
    },
    userInitials() {
      const fn = this.user.full_name;
      return fn.match((/\b(\w)/g)).join('');
    },
  },
};
</script>

<style scoped>
.layout {
    background: #efefef;
}
.main-container {
    max-width: 96%;
}
.help-content > * {
    margin-bottom: 8px;
}
.comark-footer-links {
  display: inline;
}
#appbar-logo {
  max-width: 40%;
  margin-top: 0.75rem;
}
</style>
